<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h1>Create menu</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Name</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="menuName"
                      type="text"
                      placeholder="Enter menu name"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Menu has created successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';

export default {
  name: 'MenuNew',

  mixins: [CreatePageMixin],

  data() {
    return {
      menuName: '',
    };
  },

  methods: {
    isEntityValid() {
      if (!this.menuName) {
        this.$_showError('Name field is required');
        return false;
      }
      return true;
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('name', this.menuName);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}menu`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then((response) => {
        this.$_successSave();
        this.$parent.getSource();
        window.location.hash = `#/admin/menu/edit/${response.data.id}`;
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in creating new menu ', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?0f50d0b2